<template>
  <va-card>
    <template slot="header">
      <h5 class="card-title">{{ $t('accounts.account_info') }}</h5>
    </template>
    <div class="row">
      <div class="col-12 col-sm-6 p-0">
        <div>
          <b class="profile-details-label">{{$t('accounts.name')}}:</b>
          <p>{{account.first_name}} {{account.last_name}}</p>
        </div>
        <div>
          <b class="profile-details-label">{{$t('acconts.gender')}}:</b>
          <p> {{$t(`genders.${account.gender.toLowerCase()}`)}} </p>
        </div>
        <div>
          <b class="profile-details-label">{{$t('tables.columns.birthdate')}}:</b>
          <p> {{$options.filters.localTime(account.birthdate, 'DD/MM/YYYY', '---')}}</p>
        </div>
        <div>
          <b class="profile-details-label">{{$t('accounts.updated_at')}}:</b>
          &nbsp;
          <va-popover
            :message="$options.filters.localTime(account.updated_at)"
            placement="left"
          >
            <i class="fa fa-question-circle"></i>
          </va-popover>
          <p v-if="account.updated_at">{{account.updated_at | localTime | readableDate | capitalize}}</p>
          <p v-else>---</p>
        </div>
      </div>

      <div class="col-12 col-sm-6 p-0">
        <div>
          <b class="profile-details-label">{{$t('accounts.phone')}}:</b>
          <p>{{account.phone}}</p>
        </div>
        <div>
          <b class="profile-details-label">{{$t('accounts.email')}}:</b>
          <p>{{account.email}}</p>
        </div>
        <div>
          <b class="profile-details-label">{{$t('accounts.address')}}:</b>
          <ul v-if="account.addresses && account.addresses.length">
            <li v-for="address in account.addresses" :key="address.id">• {{address | formatAdress}}</li>
          </ul>
          <p v-else>---</p>
        </div>
      </div>
    </div>
  </va-card>
</template>

<script>
import CurrentLocaleMixin from '@/mixins/CurrentLocaleMixin'

export default {
  props: {
    account: {
      type: Object,
      required: true
    }
  },
  mixins: [
    CurrentLocaleMixin
  ],
  filters: {
    capitalize: function (value) {
      return `${value.charAt(0).toUpperCase()}${value.slice(1)}`
    },
    formatAdress: function (value) {
      let address = ''
      if (value.line1 && value.line1 != null && value.line1 !== '') {
        address += value.line1
        if ((value.line2 && value.line2 != null && value.line2 !== '') || (value.postal_code && value.postal_code != null && value.postal_code !== '') || (value.city && value.city != null && value.city !== '')) address += ', '
      }
      if (value.line2 && value.line2 != null && value.line2 !== '') {
        address += value.line2
        if ((value.postal_code && value.postal_code != null && value.postal_code !== '') || (value.city && value.city != null && value.city !== '')) address += ', '
      }
      if (value.postal_code && value.postal_code != null && value.postal_code !== '') {
        address += value.postal_code
        if (value.city && value.city != null && value.city !== '') address += ', '
      }
      if (value.city && value.city != null && value.city !== '') address += value.city
      return address
    }
  }
}
</script>
